import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import bemCnFast from '@webteam/bem-cn-fast';
import { withTheme } from '@webteam/ui-contexts';
import localNames from './formik-trigger.module.pcss.js';

var bemCn = bemCnFast('wt-select-wrapper', localNames);

function FormikTriggerWrapper(props) {
  var size = props.size,
      theme = props.theme,
      className = props.className,
      error = props.error,
      label = props.label,
      note = props.note,
      children = props.children,
      dataTest = props['data-test'];
  return React.createElement("div", {
    className: cn(bemCn({
      size: size,
      theme: theme
    }), className),
    "data-test": dataTest || 'select-wrapper'
  }, renderLabel(label, size, theme), children, renderNote(note, size, theme), renderError(error, size, theme));
}

FormikTriggerWrapper.propTypes = {
  size: PropTypes.oneOf(['m', 's', 'xs']),
  theme: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  error: PropTypes.node,
  label: PropTypes.node,
  note: PropTypes.node,
  'data-test': PropTypes.string
};

function renderNote(note, size, theme) {
  if (!note) {
    return null;
  } else {
    return React.createElement("div", {
      className: cn(bemCn('note'), getErrorAndNoteTextClass(size, theme))
    }, note);
  }
}

function renderError(error, size, theme) {
  if (!error) {
    return null;
  } else {
    return React.createElement("div", {
      className: cn(bemCn('error-message'), getErrorAndNoteTextClass(size, theme))
    }, error);
  }
}

function getErrorAndNoteTextClass(size, theme) {
  var errorAndNoteTextClass = size === 'l' ? 'wt-text-2' : 'wt-text-3';

  if (theme === 'dark') {
    var _context;

    errorAndNoteTextClass = _concatInstanceProperty(_context = "".concat(errorAndNoteTextClass, " ")).call(_context, errorAndNoteTextClass, "_theme_dark");
  }

  return errorAndNoteTextClass;
}

function renderLabel(label, size, theme) {
  var labelTextClass = // eslint-disable-next-line no-nested-ternary
  size === 'xs' ? 'wt-text-3' : size === 'l' ? 'wt-text-1' : 'wt-text-2';

  if (theme === 'dark') {
    var _context2;

    labelTextClass = _concatInstanceProperty(_context2 = "".concat(labelTextClass, " ")).call(_context2, labelTextClass, "_theme_dark");
  }

  if (!label) {
    return null;
  } else {
    return React.createElement("div", {
      className: labelTextClass
    }, label);
  }
}

var FormikTriggerWrapper$1 = withTheme(FormikTriggerWrapper);

export { FormikTriggerWrapper$1 as default };
